/* Mitti & Mor sign-up forms for landing pages and Skill Toss.
 * Posts to Supabase mitti_mor.waitlist_signups (insert-only RLS for anon).
 * Captures: email or WhatsApp, child's age band, interests, consent, UTM tags,
 * landing page, and an optional game result. Never asks for the child's name.
 */
(function () {
  'use strict';

  // Keep the first-touch UTM tags for the visit, so they survive navigation.
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign'];
  var utm = {};
  try {
    var q = new URLSearchParams(location.search);
    var stored = JSON.parse(sessionStorage.getItem('mm_utm') || '{}');
    UTM_KEYS.forEach(function (k) { utm[k] = q.get(k) || stored[k] || null; });
    sessionStorage.setItem('mm_utm', JSON.stringify(utm));
  } catch (e) { UTM_KEYS.forEach(function (k) { utm[k] = null; }); }

  function normPhone(v) {
    var d = (v || '').replace(/[^0-9]/g, '');
    if (d.length === 10) d = '91' + d;
    if (d.length === 12 && d.indexOf('0') === 0) d = d.slice(1);
    return d.length >= 11 && d.length <= 15 ? d : null;
  }

  function cut(v, n) { return v ? String(v).slice(0, n) : null; }

  window.MMForm = {
    submit: function (form, extra) {
      extra = extra || {};
      var status = form.querySelector('[data-mm-status]');
      var btn = form.querySelector('button[type="submit"]');
      function say(msg, ok) { if (status) { status.textContent = msg; status.dataset.ok = ok ? '1' : '0'; } }

      if (form.querySelector('[name="mm_company"]') && form.querySelector('[name="mm_company"]').value) return Promise.resolve(false);

      var fd = new FormData(form);
      var email = (fd.get('email') || '').trim() || null;
      var waRaw = (fd.get('whatsapp') || '').trim();
      var whatsapp = waRaw ? normPhone(waRaw) : null;
      if (waRaw && !whatsapp) { say('That WhatsApp number looks short. Use 10 digits, or add your country code.'); return Promise.resolve(false); }
      if (!email && !whatsapp) { say('Add an email or a WhatsApp number so we can reach you.'); return Promise.resolve(false); }
      if (!fd.get('consent')) { say('Please tick the consent box so we can contact you.'); return Promise.resolve(false); }

      var interests = fd.getAll('interests').filter(Boolean).slice(0, 25);
      if (extra.interests) interests = extra.interests.slice(0, 25);

      var row = {
        product_handle: cut(form.dataset.handle || 'landing', 120),
        product_title: cut(form.dataset.title || null, 200),
        email: email,
        whatsapp: whatsapp,
        child_age_band: cut(fd.get('child_age_band') || null, 40),
        source: form.dataset.source || 'landing',
        consent_at: new Date().toISOString(),
        utm_source: cut(utm.utm_source, 200),
        utm_medium: cut(utm.utm_medium, 200),
        utm_campaign: cut(utm.utm_campaign, 200),
        landing_page: cut(location.pathname, 300),
        interests: interests.length ? interests : null,
        game_result: extra.game_result || null
      };

      if (btn) btn.disabled = true;
      say('Saving…', true);
      return fetch(form.dataset.url + '/rest/v1/waitlist_signups', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Content-Profile': 'mitti_mor',
          'apikey': form.dataset.key,
          'Authorization': 'Bearer ' + form.dataset.key,
          'Prefer': 'return=minimal'
        },
        body: JSON.stringify(row)
      }).then(function (r) {
        if (btn) btn.disabled = false;
        if (r.ok || r.status === 409) {
          say(r.status === 409 ? 'You were already on the list. We’ll be in touch.' : (form.dataset.success || 'You’re on the list.'), true);
          form.classList.add('is-done');
          try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('mm_lead', { source: row.source, handle: row.product_handle }); } catch (e) {}
          document.dispatchEvent(new CustomEvent('mm:signup', { detail: row }));
          return true;
        }
        say('Something went wrong. Please try again, or message us on WhatsApp.');
        return false;
      }).catch(function () {
        if (btn) btn.disabled = false;
        say('No connection. Please try again in a moment.');
        return false;
      });
    }
  };

  // WhatsApp is the default; [data-mm-switch] swaps to email and back.
  // Markup: [data-mm-field="whatsapp|email"] wrappers (inactive one hidden, its input disabled)
  // and optional [data-mm-when="whatsapp|email"] bits shown only in that mode.
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-mm-switch]');
    if (!b) return;
    var f = b.closest('form');
    if (!f) return;
    e.preventDefault();
    var mode = (f.dataset.mode || 'whatsapp') === 'whatsapp' ? 'email' : 'whatsapp';
    f.dataset.mode = mode;
    f.querySelectorAll('[data-mm-field]').forEach(function (w) {
      var on = w.getAttribute('data-mm-field') === mode;
      w.hidden = !on;
      w.querySelectorAll('input').forEach(function (i) { i.disabled = !on; });
      if (on) { var i = w.querySelector('input'); if (i) i.focus(); }
    });
    f.querySelectorAll('[data-mm-when]').forEach(function (w) { w.hidden = w.getAttribute('data-mm-when') !== mode; });
    b.textContent = mode === 'email' ? (b.dataset.toWa || 'Use WhatsApp instead') : (b.dataset.toEmail || 'Use email instead');
    var st = f.querySelector('[data-mm-status]'); if (st) st.textContent = '';
  });

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('form[data-mm-form]')) return;
    e.preventDefault();
    window.MMForm.submit(f);
  });
})();
